import styled from "styled-components";

const colorMapper = {
  success: "#1FAA59",
  warning: "#EDC126",
  error: "#BF3325",
};

export const MyToast = styled.div`
  position: absolute;
  bottom: 30px;
  max-width: 360px;
  width: auto;
  left: 10px;
  color: white;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  background: ${(props: { type?: string }) =>
    props.type && colorMapper[props.type as keyof typeof colorMapper]}; ;
`;

export const CrossIcon = styled.button`
  outline: none;
  border: none;
  color: white;
  background: transparent;
  font-size: 16px;
  cursor: pointer;
  margin-left: 8px;
`;
